<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
    		<search-snb></search-snb>
        </keep-alive>
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import axios       from 'axios';
import SDLUtil     from '@/utils/SDLUtil';

import SearchSnb   from './SearchSnb';

export default {
    name: 'Search',
    components: {
    	'search-snb' : SearchSnb
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/Search.vue